import firebase from "firebase";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDganbRAklyRQ2UAkYOwX4y0XMrX6eemv8",
  authDomain: "green-shade.firebaseapp.com",
  projectId: "green-shade",
  storageBucket: "green-shade.appspot.com",
  messagingSenderId: "133659751556",
  appId: "1:133659751556:web:cfd32bdc0360fa1a1e3ed1",
  measurementId: "G-R43VSW751J"
};
firebase.initializeApp(firebaseConfig);

// utils
const db = firebase.firestore();
const auth = firebase.auth();

// collection references
const usersCollection = db.collection("users");
const entityCollection = db.collection("entity");

// export utils/refs
export { db, auth, usersCollection, entityCollection };
